module.exports = __webpack_public_path__ + "static/media/plus.cd03b745.svg";